import Echo from 'laravel-echo'
import { constants } from '../constants'
const Pusher = require('pusher-js')

export default new Echo({
    authEndpoint: `${constants.serverUri}/broadcasting/auth`,
    auth: {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: 'application/json'
        }
    },
    broadcaster: 'pusher',
    key: 'cd99f85be50c7f8e1769',
    cluster: 'ap2',
    encrypted: true
})
